import FileIcon from "@mui/icons-material/InsertDriveFile";
import PreviewIcon from "@mui/icons-material/Preview";
import RemoveIcon from "@mui/icons-material/Remove";
import { IconButton, ListItem, ListItemText, Stack, useTheme } from "@mui/material";
import { Document } from "generated-graphql/graphql";

export const DocumentListItem = ({
  document: file,
  onDelete,
  onEdit,
  onPreview,
}: {
  document: Pick<Document, "title" | "sizeMegabytes">;
  onDelete: () => void;
  onEdit?: () => void;
  onPreview: () => void;
}) => {
  const theme = useTheme();
  return (
    <Stack
      direction="row"
      spacing={1}
      alignItems="center"
      borderRadius="4px"
      sx={{ "&:not(:last-child)": { mb: theme.spacing(3) } }}
      onClick={onEdit}
    >
      <ListItem
        sx={{ bgcolor: "#517BC61F", borderRadius: "4px" }}
        secondaryAction={
          <IconButton
            edge="end"
            aria-label="preview-document"
            onClick={(e) => {
              e.stopPropagation();
              onPreview();
            }}
            color="primary"
          >
            <PreviewIcon />
          </IconButton>
        }
      >
        <Stack
          sx={{
            minWidth: theme.spacing(5),
            justifyContent: "center",
          }}
        >
          <FileIcon color="action" />
        </Stack>
        <ListItemText
          primary={file.title}
          secondary={file.sizeMegabytes ? formatFileSize(file.sizeMegabytes) : undefined}
        />
      </ListItem>
      <IconButton
        size="medium"
        aria-label="remove-document"
        onClick={(e) => {
          e.stopPropagation();
          onDelete();
        }}
      >
        <RemoveIcon />
      </IconButton>
    </Stack>
  );
};

const formatFileSize = (sizeInBytes: number): string => {
  if (sizeInBytes < 1024) {
    return `${sizeInBytes} B`;
  }
  if (sizeInBytes < 1024 * 1024) {
    return `${(sizeInBytes / 1024).toFixed(2)} KB`;
  }
  return `${(sizeInBytes / 1024 / 1024).toFixed(2)} MB`;
};
